import React, { useEffect } from 'react';
import styles from './curso_beatriz_martinsstudio.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5517992254400';

const Curso_beatriz_martinsstudio: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openWhatsApp = () => {
        const msg = encodeURIComponent('Olá! Vim pelo cartão digital e gostaria de mais informações sobre os cursos.');
        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`, '_blank');
    };

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.curso_beatriz_martinsstudio}>
                <div className={styles.header}>
                    <Link to="/beatriz_martinsstudio" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Curso</h2>
                </div>

                <div className={styles.hero}>
                    <img
                        src={require('./src/curso.png')}
                        alt="Cursos Beatriz Martins Studio"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <div className={styles.card}>
                        <p className={styles.lead}>
                            Se você deseja iniciar na área da beleza ou se aperfeiçoar em uma das áreas que mais cresce no mercado, os
                            Cursos Profissionais foram desenvolvidos para você.
                        </p>
                        <p className={styles.paragraph}>
                            Com uma metodologia clara, prática e acessível, ensino passo a passo as técnicas utilizadas no meu dia a dia
                            profissional, para que você se sinta segura para atender suas primeiras clientes e construir sua própria
                            carreira.
                        </p>
                    </div>

                    <div className={styles.grid}>
                        <div className={styles.sectionCard}>
                            <h3>Atualmente, ministro cursos nas áreas de</h3>
                            <ul>
                                <li>Design de Sobrancelhas</li>
                                <li>Micropigmentação Labial</li>
                                <li>Brow Lamination</li>
                            </ul>
                        </div>

                        <div className={styles.sectionCard}>
                            <h3>O que você irá aprender</h3>
                            <ul>
                                <li>Estrutura e anatomia das sobrancelhas</li>
                                <li>Visagismo aplicado ao design</li>
                                <li>Mapeamento facial</li>
                                <li>Técnicas de design com pinça e correção</li>
                                <li>Simetria e harmonia do olhar</li>
                                <li>Preparação da pele e finalização</li>
                                <li>Atendimento ao cliente</li>
                                <li>Dicas para começar a trabalhar e conquistar suas primeiras clientes</li>
                            </ul>
                        </div>

                        <div className={styles.sectionCard}>
                            <h3>Para quem é o curso</h3>
                            <ul>
                                <li>Iniciantes que desejam entrar na área da beleza</li>
                                <li>Profissionais que querem aperfeiçoar sua técnica</li>
                                <li>Pessoas que buscam independência financeira</li>
                            </ul>
                        </div>

                        <div className={styles.sectionCard}>
                            <h3>Diferenciais do curso</h3>
                            <ul className={styles.checkList}>
                                <li>Acompanhamento próximo durante o aprendizado</li>
                                <li>Conteúdo teórico + prática</li>
                                <li>Dicas reais do mercado da beleza</li>
                                <li>Certificado de conclusão</li>
                            </ul>
                        </div>
                    </div>

                    <div className={styles.card}>
                        <p className={styles.paragraph}>
                            Ao final do curso, você estará preparada para iniciar seus atendimentos com mais segurança e profissionalismo.
                        </p>
                        <div className={styles.callout}>
                            <span className={styles.calloutTitle}>Vagas limitadas</span>
                            <span className={styles.calloutText}>Para mais informações ou para garantir sua vaga, entre em contato.</span>
                        </div>
                        <button type="button" className={styles.ctaButton} onClick={openWhatsApp}>
                            Falar no WhatsApp
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Curso_beatriz_martinsstudio;
